import React, { useContext } from 'react';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../../contexts/AuthProvider';
import { MdOutlineSettingsSuggest } from "react-icons/md";

const Navbar = () => {

    const {user, logOut} = useContext(AuthContext);

    const handleLogOut = () => {
        logOut()
        .then( () => {
            toast.success('Successfully Logged Out');
        })
        .catch( error => console.error(error.message))
    }

    const menuItems = <React.Fragment>
        <li><Link to='/home' className='text-black rounded-lg hover:bg-gradient-to-r from-[#F44369] to-[#D64270] hover:text-white'>Home</Link></li>
        <li><Link to='/allCategory' className='text-black rounded-lg hover:bg-gradient-to-r from-[#F44369] to-[#D64270] hover:text-white'>Category</Link></li>
        <li><Link className='text-black rounded-lg hover:bg-gradient-to-r from-[#F44369] to-[#D64270] hover:text-white' to='/blog'>Blog</Link></li>
        {user?.uid ? 
            <>
                <li><Link className='text-black rounded-lg hover:bg-gradient-to-r from-[#F44369] to-[#D64270] hover:text-white' to='/dashboard'>Dashboard</Link></li>
                <li><button onClick={handleLogOut} className="text-black rounded-lg hover:bg-gradient-to-r from-[#F44369] to-[#D64270] hover:text-white">Log Out</button></li>
            </>
            :
            <li><Link className='text-black rounded-lg hover:bg-gradient-to-r from-[#F44369] to-[#D64270] hover:text-white' to='/login'>Login</Link></li>
        }
    </React.Fragment>

    return (
        <div className="navbar bg-gray-200 w-full flex justify-between">
            <div className="navbar-start">
                <div className="dropdown">
                    <label tabIndex={0} className="btn btn-ghost lg:hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                    </label>
                    <ul tabIndex={1} className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
                        {menuItems}
                    </ul>
                </div>
                <Link to='/' className="text-transparent bg-clip-text bg-gradient-to-r from-[#F44369] to-[#D64270] lg:text-2xl sm:font-bold font-bold">Endless Essentials</Link>
            </div>
            <div className="navbar-center hidden lg:flex">
                <ul className="menu menu-horizontal p-0">
                    {menuItems}
                </ul>
            </div>
            <label htmlFor="dashboard-drawer" tabIndex={2} className="btn btn-ghost lg:hidden">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
            </label>
        </div>
    );
};

export default Navbar;